<template>
  <VuePerfectScrollbar class="bbp-proforma" v-click-outside="closeProforma">
    <input v-autofocus class="bbp-proforma__hide" @keyup.esc="closeProforma">
    <transition name="bbp-fade" appear>
      <BBPLoader v-if="loaderRun"></BBPLoader>
    </transition>
    <i class="bbp-icon-cross bbp-proforma__close" @click="closeProforma"/>
    <div class="bbp-proforma-header">
      <div class="bbp-proforma-header-title">
        <img class="bbp-proforma-header-title__logo"
             :src="companyLogo">
        <h1 class="bbp-proforma-header-title__text">
          PROFORMA <span class="bbp-proforma__text-accent">INVOICE*</span>
        </h1>
      </div>
    </div>
    <div class="bbp-proforma-details">
      <div class="bbp-proforma-details-section">
        <div class="bbp-proforma-details-section__header bbp-proforma-details-section__header_first">
          DETAILS
        </div>
        <div class="bbp-proforma-details-section-item bbp-proforma-details-section-item_ref">
          <div class="bbp-proforma-details-section-item__title">
            <span>Issued to:</span>
          </div>
          <div class="bbp-proforma-details-section-item-client-info">
            <div class="bbp-proforma-details-section-item-client-info__name">
              <pre>{{issuedTo}}</pre>
            </div>
          </div>
        </div>
        <div class="bbp-proforma-details-section-item">
          <div class="bbp-proforma-details-section-item__title">
            Description:
          </div>
          <div>
            {{servicesCategories}}
          </div>
        </div>
      </div>
      <div class="bbp-proforma-details-section">
        <div class="bbp-proforma-details-section__header bbp-proforma-details-section__header_last">
          PROFORMA{{space}}INVOICE
        </div>
        <div class="bbp-proforma-details-section-item bbp-proforma-details-section-item_ref">
          <div class="bbp-proforma-details-section-item__title">
            REF:
          </div>
          <div>
            {{invoice.number}}
          </div>
        </div>
        <div class="bbp-proforma-details-section_date">
          <div class="bbp-proforma-details-section-item">
            <div class="bbp-proforma-details-section-item__title bbp-proforma-details-section-item__title_center">
              Issue Date:
            </div>
            <div>{{issueDate}}</div>
          </div>
          <div class="bbp-proforma-details-section-item">
            <div class="bbp-proforma-details-section-item__title bbp-proforma-details-section-item__title_center">
              Due Date:
            </div>
            <div>{{dueDate}}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bbp-proforma-service-list">
      <div
        class="
          bbp-proforma-service-list-row
          bbp-proforma-service-list-row_header
          bbp-proforma-service-list-row_pdf
       "
        :class="[
          'bbp-proforma-service-list-row',
          'bbp-proforma-service-list-row_header',
          'bbp-proforma-service-list-row_pdf',
          !showDiscount && 'bbp-proforma-service-list-row_pdf-without-discount'
        ]"
      >
        <div>#</div>
        <div>SERVICE{{space}}DESCRIPTION</div>
        <div class="bbp-proforma-service-list-row__center">PRICE, AED</div>
        <div class="bbp-proforma-service-list-row__center">QTY.</div>
        <div
          v-if="showDiscount"
          class="bbp-proforma-service-list-row__center"
        >
          DISCOUNT
        </div>
        <div class="bbp-proforma-service-list-row__center">AMOUNT, AED</div>
        <div class="bbp-proforma-service-list-row__center">VAT RATE</div>
        <div class="bbp-proforma-service-list-row__center">VAT AMOUNT</div>
        <div class="bbp-proforma-service-list-row__center">TOTAL, AED</div>
      </div>
      <div
        :class="[
          'bbp-proforma-service-list-row',
          'bbp-proforma-service-list-row_pdf',
          !showDiscount && 'bbp-proforma-service-list-row_pdf-without-discount'
        ]"
        v-for="(service,index) in invoice.services"
        :key="service.id"
      >
        <!-- index -->
        <div class="bbp-proforma-service-list-row__index">
          {{index + 1}}.
        </div>
        <!-- service name -->
        <div>
          {{getNameCategory(service, service.category)}}
          re.
          {{service.name}}
        </div>

        <!-- amount -->
        <div class="bbp-proforma-service-list-row__center bbp-proforma-service-list-row__amount">
          <div class="bbp-proforma-service-list-row__center">{{convertNumber(amount(service).amount)}}</div>
        </div>
        <!-- qty -->
        <div class="bbp-proforma-service-list-row__center">
          {{service.quantity}}
        </div>
        <div
          v-if="showDiscount"
          class="bbp-proforma-service-list-row__center"
        >
          {{ discount.number[service.id] ? `${discount.number[service.id]} %` : `-`}}
        </div>
        <!-- amount -->
        <div class="bbp-proforma-service-list-row__center">
          {{convertNumber(amount(service).total)}}
        </div>
        <div class="bbp-proforma-service-list-row__center">
          {{service.vat}}
        </div>
        <!-- vat amount -->
        <div class="bbp-proforma-service-list-row__center">
          {{convertNumber(amount(service).vatAmount)}}
        </div>
        <!-- total amount -->
        <div class="bbp-proforma-service-list-row__center">
          {{convertNumber(amount(service).allTotal)}}
        </div>
      </div>
    </div>
    <div class="bbp-proforma-total">
      <div class="bbp-proforma-total-terms">
        <div class="bbp-proforma-total-terms__title">TERMS & CONDITIONS</div>
        <span>{{texts.conditions.text}}</span>
        <span class="bbp-proforma__text-accent">{{texts.conditions.accent}}</span>
      </div>
      <div class="bbp-proforma-total-calculations">
        <div class="bbp-proforma-total-calculations__row">
          <span>SUBTOTAL (EXCL. VAT):</span>
          <span>{{convertNumber(subTotal())}}</span>
        </div>
        <div class="bbp-proforma-total-calculations__row">
          <span>VAT:</span>
          <span>{{convertNumber(totalVat())}}</span>
        </div>
        <div
          v-if="addAdditionalPay"
          class="bbp-proforma-total-calculations__row bbp-proforma-total-calculations__row_underpaid"
        >
          <span>PREVIOUS DUES</span>
          <span>AED {{convertNumber(additionalPay)}}</span>
        </div>
        <div class="bbp-proforma-total-calculations__totals">
          <transition name="fade">
            <div
              class="bbp-proforma-total-calculations__row bbp-proforma-total-calculations__row_accent
                          bbp-proforma-total-calculations__row_total"
            >
              <span>TOTAL</span>
              <span>
                  AED {{addAdditionalPay || includeCreditNotes
                ? convertNumber(payment().toBePay)
                : convertNumber(payment().AED)}}
                </span>
            </div>
          </transition>
          <transition name="fade">
            <div class="bbp-proforma-total-calculations__row bbp-proforma-total-calculations__row_accent
                          bbp-proforma-total-calculations__row_total"
            >
              <span>PAYMENT</span>
              <span>AED {{convertNumber(invoice.payments)}}</span>
            </div>
          </transition>
          <transition name="fade">
            <div class="bbp-proforma-total-calculations__row bbp-proforma-total-calculations__row_accent
                          bbp-proforma-total-calculations__row_total"
            >
              <span>CREDITS APPLIED</span>
              <span>AED {{convertNumber(invoice.creditNotes)}}</span>
            </div>
          </transition>
          <transition name="fade">
            <div class="bbp-proforma-total-calculations__row bbp-proforma-total-calculations__row_accent
                          bbp-proforma-total-calculations__row_total"
            >
              <span>TOTAL DUE:</span>
              <span>
                  AED {{convertNumber(totalDue())}}
                </span>
            </div>
          </transition>
        </div>
      </div>
    </div>
    <div class="bbp-proforma-bank">
      <div class="bbp-proforma-bank-name bbp-proforma__text-accent">
        <div>Please mention the following payment reference:</div>
        <span class="bbp-proforma-bank-name__reference">
          REF {{invoice.number}} {{servicesCategories}}
        </span>
      </div>
      <div class="bbp-proforma-bank-details">
        <div class="bbp-proforma-bank-details__title">
          Bank Account Payment Details
        </div>
      </div>
      <div class="bbp-proforma-bank-card">
        <div class="bbp-proforma-bank-card__item">
          <pre>{{bankAccountDetails}}</pre>
        </div>
        <div class="bbp-proforma-bank-card__item bbp-proforma-bank-card__item_iban" v-if="bankDetailsIban.aed">
          AED Account: {{bankDetailsIban.aed}}
        </div>
        <div class="bbp-proforma-bank-card__item bbp-proforma-bank-card__item_iban" v-if="bankDetailsIban.usd">
          USD Account: {{bankDetailsIban.usd}}
        </div>
        <div class="bbp-proforma-bank-card__item bbp-proforma-bank-card__item_iban" v-if="bankDetailsIban.eur">
          EUR Account: {{bankDetailsIban.eur}}
        </div>
      </div>
    </div>
    <div class="bbp-proforma-footer">
      <div class="bbp-proforma-footer__row">Thank you for your trust in our services. We value your business.</div>
    </div>
  </VuePerfectScrollbar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import defaultLogoCompany from '@/assets/images/logo-company.png'
import CompanyApi from '@/api/Company/api'
import convertNumber from '@/mixin/convertNumber'
import BBPLoader from '@/components/Main/BBPLoader/BBPLoader'
import serviceCategories from '@/constants/servicesCategories'
import InvoiceApi from '@/api/Invoice/api'
import _, {get, forEach, isNull, uniq, find, round} from 'lodash'
import moment from 'moment'

export default {
  name: 'BBPProforma',
  props: ['invoice'],
  mixins: [convertNumber],
  components: {
    BBPLoader,
    VuePerfectScrollbar
  },
  data () {
    return {
      clientTotals: {
        overpaid: 0,
        underpaid: 0,
        ratio: 0,
        status: ''
      },
      additionalPay: 0,
      serviceCategories: serviceCategories,
      space: String.fromCharCode(160),
      loaderRun: false,
      defaultLogoCompany: defaultLogoCompany,
      currentCompany: {},
      texts: {
        conditions: {
          text: 'The amount is payable in full in advance into bank account.',
          accent: 'Dear Customer, kindly be advised that current invoice shall be ' +
            'considered paid only when the full amount is credited. ' +
            'Please, make sure that all related transfer charges are covered by the sender.'
        }
      },
      discount: {
        status: {},
        number: {}
      },
      servicesChecked: [],
      addAdditionalPay: false,
      includeCreditNotes: false,
      currentCreditNotes: 0
    }
  },
  computed: {
    bankAccountName () {
      return get(this.invoice, 'bankAccount.name', '')
    },
    bankAccountDetails () {
      return get(this.invoice, 'bankAccount.details', '')
    },
    bankDetailsIban () {
      return get(this.invoice, 'bankAccount.iban', {})
    },
    companyVat () {
      return get(this.currentCompany, 'settings.vat', '')
    },
    companyLogo () {
      return get(this.currentCompany, 'image.path', this.defaultLogoCompany)
    },
    issueDate () {
      return moment(this.invoice.issueDate).format('DD-MMM-YY')
    },
    dueDate () {
      return moment(this.invoice.dueDate).format('DD-MMM-YY')
    },
    issuedTo () {
      const typePropClient = get(this.invoice, 'client.clientType', '')
      const invoiceType = get(this.invoice, `client.${typePropClient}`, 1)
      const individual = +invoiceType === 1
      const entity = +invoiceType === 2
      if (individual) {
        return this.setIssuedToIndividual()
      } else if (entity) {
        return this.setIssuedToEntity()
      } else {
        return get(this.invoice, 'issuedTo', '')
      }
    },
    servicesCategories () {
      const categoryArr = []
      forEach(this.invoice.services, service => {
        if (!(isNull(service.category))) {
          categoryArr.push(this.getNameCategory(service, service.category))
        }
      })
      return uniq(categoryArr).join(`${this.space}and${this.space}`)
    },
    totalServicesVat () {
      return this.invoice.services.reduce((accumulator, currentValue) => {
        if (+currentValue.vat < 1 || isNaN(currentValue.vat)) {
          return accumulator
        }
        return (accumulator + (+this.amount((currentValue)).total))
      }, 0)
    },
    totalServices () {
      return this.invoice.services.reduce((accumulator, currentValue) => {
        return (accumulator + (+this.amount((currentValue)).total))
      }, 0)
    },
    showDiscount () {
      const status = Object.values(this.discount.status)
      return status.some(item => item)
    }
  },
  methods: {
    getNameCategory (service, category) {
      let idCategory = service.serviceType || category
      if (service.serviceType === 0) idCategory = 0
      const res = find(this.serviceCategories, item => item.id === idCategory)
      return res ? res.name : ''
    },
    getCompanyById () {
      const companyId = get(this.invoice, 'company', '')
      if (!companyId) return
      this.loaderRun = true
      CompanyApi.getCompaniesById(companyId)
        .then(resp => {
          this.loaderRun = false
          this.currentCompany = resp.data
          this.setServicesForEditable()
        })
        .catch(err => {
          this.loaderRun = false
          console.error(err)
        })
    },
    closeProforma () {
      this.$emit('close')
    },
    setIssuedToIndividual () {
      const firstName = get(this.invoice, 'client.firstName', '')
      const lastName = get(this.invoice, 'client.lastName', '')
      const address = get(this.invoice, 'client.address', '')
      const issuedTo = get(this.invoice, 'issuedTo', '')
      const issued = issuedTo && issuedTo !== 'false'
      return issued ? issuedTo : firstName + ' ' + lastName + '\n' + address
    },
    setIssuedToEntity () {
      const clientCompany = get(this.invoice, 'client.clientCompany', '')
      const clientCompanyDetails = get(this.invoice, 'client.clientCompanyDetails', '')
      const issuedTo = get(this.invoice, 'issuedTo', '')
      const issued = issuedTo && issuedTo !== 'false'
      return issued ? issuedTo : clientCompany + '\n' + clientCompanyDetails
    },
    validateNum (num) {
      let trueNumber = num
      if (typeof trueNumber === 'string') {
        trueNumber = +trueNumber.replace(/[-,]/, '')
      }
      return isNaN(trueNumber) ? 0 : trueNumber
    },
    getInvoicesTotal () {
      const additionalPay = get(this.invoice, 'additionalPay', 0)
      const clientID = get(this.invoice, 'client.id', '')
      const query = 'isDelete[]=false&client[]=' + clientID
      InvoiceApi.getInvoicesTotal({query})
        .then((resp) => {
          const overpaid = get(resp.data, 'totalOverpaid', 0)
          const underpaid = get(resp.data, 'totalUnderpaid', 0)
          const ratio = this.roundNum(overpaid - underpaid)
          this.clientTotals = {
            overpaid: overpaid,
            underpaid: underpaid,
            ratio: ratio
          }
          this.clientTotals.status = this.setStatusBalance(ratio)
          const differentSignNumber = (ratio > 0 && additionalPay < 0) || (ratio < 0 && additionalPay > 0)
          if (differentSignNumber) {
            this.additionalPay = 0
          }
        })
        .catch((err) => {
          console.error(err)
        })
    },
    setStatusBalance (ratio) {
      if (ratio > 0) {
        return 'overpaid'
      } else if (ratio < 0) {
        return 'underpaid'
      } else {
        return ''
      }
    },
    roundNum (num) {
      return round(num, 2)
    },
    amount (service) {
      const extra = service.extraValue ? this.validateNum(service.extraValue) : 0
      const amount = this.validateNum(service.value) + extra
      const qty = service.quantity
      const discount = this.discount.number[service.id]
      const pureTotal = (amount * qty)
      let vat = service.vat
      let total = pureTotal
      if (discount) {
        total = pureTotal - (pureTotal * discount / 100)
      }
      if (isNaN(service.vat)) {
        vat = 0
      }
      const vatAmount = (total * vat) / 100
      const allTotal = vatAmount + total
      return {
        amount: amount,
        extra: extra,
        vatAmount: vatAmount,
        allTotal: allTotal,
        total: total
      }
    },
    subTotal () {
      return this.servicesChecked.reduce((sum, item) => {
        sum += this.amount(item).total
        return sum
      }, 0)
    },
    totalVat () {
      return this.servicesChecked.reduce((sum, item) => {
        sum += this.amount(item).vatAmount
        return sum
      }, 0)
    },
    totalDue () {
      const received = _.get(this.invoice, ['received'], 0)
      const result = this.payment().toBePay - received
      return result > 0 ? result : 0
    },
    payment () {
      const vat = get(this.currentCompany, 'settings.vat', 5)
      const usdRate = get(this.invoice, 'bankAccount.currencyRates.usd', 3.67)
      const eurRate = get(this.invoice, 'bankAccount.currencyRates.eur', 3.9)
      const vatAED = this.roundNum(this.totalServicesVat) * this.roundNum(vat) / 100
      const totalVat = this.totalVat()
      const additionalPay = this.roundNum(this.additionalPay || 0)
      const totalAed = this.roundNum(this.totalServices) + this.roundNum(totalVat)
      let toBePay = totalAed
      if (this.addAdditionalPay) toBePay = toBePay + additionalPay
      if (this.includeCreditNotes) toBePay = toBePay - this.currentCreditNotes
      const totalUsd = toBePay / +usdRate
      const totalEur = toBePay / +eurRate
      return {
        vatAED: vatAED,
        AED: this.roundNum(totalAed),
        USD: this.roundNum(totalUsd),
        EUR: this.roundNum(totalEur),
        toBePay: this.roundNum(toBePay),
        course: {
          usd: usdRate,
          euro: eurRate
        }
      }
    },
    setServicesForEditable () {
      const { services = [] } = this.invoice
      const checkedServices = services.map((item) => {
        item.serviceType = item.category
        item.originValue = +item.value + +item.extraValue
        if (item.discount > 0) {
          this.discount = _.cloneDeep(this.discount)
          this.discount.status[item.id] = true
          this.discount.number[item.id] = item.discount
        }
        return item
      })
      if (checkedServices.length > 0) this.servicesChecked = checkedServices
    }
  },
  beforeMount () {
    this.getCompanyById()
    const { additionalPreviousDues = 0, additionalCreditNotePay = 0 } = this.invoice
    this.addAdditionalPay = additionalPreviousDues !== 0
    this.additionalPay = additionalPreviousDues
    this.currentCreditNotes = additionalCreditNotePay
    this.includeCreditNotes = additionalCreditNotePay
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-proforma {
    @include global-font;
    position: relative;
    padding: 30px;
    background-color: $color-white;
    border-radius: 8px;
    max-height: 90vh;
    width: 760px;

    &__hide {
      position: absolute;
      width: 0;
      height: 0;
      opacity: 0;
      overflow: hidden;
    }

    &__close {
      position: absolute;
      top: 11px;
      right: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $color-silver;
      width: 26px;
      height: 26px;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color-dusty-gray
      }
    }

    &__text-accent {
      color: $color-crimson;
    }

    &-header {
      margin-bottom: 16px;

      &-title {
        display: flex;
        justify-content: center;
        align-items: center;

        &__logo {
          margin-right: 13px;
          width: 41px;
          height: 41px;
          padding: 1px;
          border-radius: 50%;
        }

        &__text {
          font-size: 31px;
          font-weight: 600;
          line-height: 53px;
        }
      }

      &__note {
        margin-top: 6px;
        text-align: center;
        font-size: 11px;
        line-height: 15px;
      }
    }

    &-details {
      display: flex;

      &-section {
        display: flex;
        flex-direction: column;
        position: relative;
        width: 100%;
        margin: 0 -1px;

        &__header {
          display: flex;
          align-items: center;
          background: $color-guardsman-red;
          height: 38px;
          color: $color-white;
          font-size: 10px;
          line-height: 17px;
          font-weight: 500;
          padding-left: 17px;
          margin-bottom: 13px;
          white-space: nowrap;

          &_first {
            border-radius: 5px 0 0 5px;
          }

          &_last {
            border-radius: 0 5px 5px 0;
          }
        }

        &_date {
          margin-top: auto;
        }

        &-item {
          padding-left: 17px;
          display: flex;
          font-size: 10px;
          line-height: 17px;
          margin-bottom: 11px;

          &_ref {
            margin-bottom: -20px;
            min-height: 50px;
          }

          &__title {
            min-width: 110px;
            font-weight: 700;

            &_center {
              align-self: center;
            }
          }

          &-client-info {
            position: relative;
            width: 100%;

            &__edit {
              position: absolute;
              left: 81%;
              top: 0;
              display: flex;
              justify-content: center;
              align-items: center;
              border-radius: 50%;
              font-size: 10px;
              width: 21px;
              height: 21px;
              cursor: pointer;
              user-select: none;
            }

            &__name {
              width: 80%;
              max-width: 325px;
              margin-bottom: 7px;
              height: auto;
              line-height: 26px;
              border: 1px solid transparent;

              &_border {
                border: 1px solid $color-wild-sand;
                box-sizing: border-box;
                border-radius: 5px;
              }

              pre {
                white-space: pre-line;
                line-height: 17px;
              }
            }
          }
        }
      }
    }

    &-service-list {
      &-row {
        display: grid;
        grid-template-columns: 20px 370px 120px 30px 80px;
        grid-gap: 17px;
        align-items: center;
        justify-content: space-between;
        padding: 8px 17px;
        font-size: 13px;
        line-height: 14px;

        &_expire {
          grid-template-rows: 1fr 1fr;
          grid-gap: 6px 17px;
        }

        &_header {
          padding: 12px 17px;
          color: $color-white;
          font-size: 10px;
          line-height: 16px;
          font-weight: 500;
          background: $color-guardsman-red;
          border-radius: 5px;
          margin-bottom: 10px;
        }

        &__center {
          display: inline-flex;
          justify-content: center;
          text-align: center;

          &_hide {
            display: none;
          }
        }

        &__extra-icon {
          width: 21px;
          height: 21px;
          font-size: 21px;
        }

        &__amount {
          position: relative;
        }

        &-extra {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-gap: 10px;

          &-item {
            position: relative;
            display: grid;
            align-items: center;
            justify-content: center;

            &__title {
              position: absolute;
              top: -15px;
              left: 0;
              width: 100%;
              font-size: 10px;
              color: $color-dusty-gray;
              text-align: center;
            }
          }
        }

        &__index {
          font-weight: 500;
        }

        &-expire {
          display: grid;
          align-items: center;
          grid-template-columns: auto 1fr;
          grid-template-rows: 1fr;
          grid-gap: 6px;
          height: 32px;

          &_include {
            grid-template-columns: 150px 14px;
            user-select: none;
            cursor: pointer;
          }

          &__checkbox {
            pointer-events: none;
          }

          &-container {
            grid-column: 2/9;
            display: grid;
            align-items: center;
            justify-content: start;
            grid-template-columns: auto 1fr 1fr;
            grid-gap: 17px;
          }

          &__label {
            font-weight: 500;
            line-height: 14px;
            transition: 0.3s;

            &_include {
              &:hover {
                opacity: 0.7;
              }
            }
          }

          &__no-entries {
            color: $color-guardsman-red;
          }
        }

        &__input {
          display: block;
          width: 100%;
          box-sizing: border-box;
          border-radius: 2px;
          padding: 3px 6px;
          border: 1px solid $color-wild-sand;

          &:disabled {
            border-color: transparent;
          }

          &_center {
            text-align: center;
            background-color: transparent;
            color: $color-black;
          }
        }

        &-discount {
          display: grid;
          grid-template-columns: 21px 30px 10px;
          align-items: center;
          grid-gap: 5px;

          &__icon {
            color: $color-silver;
            font-size: 13px;
          }
        }

        &_pdf {
          grid-template-columns: 15px 160px 50px 20px 66px 37px 45px 37px 52px;
          font-size: 10px;

          &__input {
            border-color: transparent;
          }
        }
        &_pdf-without-discount {
          grid-template-columns: 15px 160px 50px 20px 60px 27px 47px 41px;
        }
      }
    }

    &-total {
      display: flex;
      justify-content: space-between;
      margin-top: 24px;

      &-terms {
        max-width: 275px;
        font-size: 10px;
        line-height: 15px;

        &__title {
          margin-bottom: 5px;
          font-size: 10px;
          line-height: 18px;
        }
      }

      &-calculations {
        display: flex;
        flex-direction: column;
        width: 325px;
        min-height: 169px;
        padding: 14px 20px;
        margin-left: 12px;
        box-sizing: border-box;
        border-radius: 6px;

        &__totals {
          border: 1px solid $color-wild-sand;
          padding: 14px 20px;
          margin: 0 -20px;
          box-sizing: border-box;
          border-radius: 6px;
        }

        &__row {
          display: flex;
          justify-content: space-between;
          font-size: 10px;
          font-weight: 700;
          line-height: 16px;
          margin-bottom: 10px;

          &_additional {
            min-height: 24px;
          }

          &_view {
            cursor: pointer;

            &:hover {
              opacity: 0.6;
            }
          }

          &_old {
            opacity: 0.5;
          }

          &_accent {
            color: $color-guardsman-red;
          }

          &__applied {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: -8px;
            height: 24px;

            &_old {
              height: auto;
            }

            &_input {
              @include global-font;
              margin-left: 5px;
              font-size: 13px;
              height: 100%;
              max-width: 68px;
              text-align: center;
              padding: 5px 4px;
            }
          }

          &_overpaid {
            color: $color-japanese-laurel;
          }

          &_underpaid {
            color: $color-pomegranate;
          }

          &:last-child {
            margin-bottom: 0;
          }

          &_vat {
            font-size: 13px;
            font-weight: normal;
            line-height: 15px;
          }

          &_total {
            margin-bottom: 8px;
          }
        }
      }
    }

    &-bank {
      &-name {
        margin-top: 17px;
        text-align: center;
        font-size: 10px;
        font-weight: 600;
        line-height: 17px;

        &__reference {
          border-bottom: 1px solid $color-crimson;
        }
      }

      &-details {
        margin-top: 11px;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 30px;

        &__title {
          font-size: 10px;
          font-weight: 700;
          line-height: 17px;

          &_save {
            margin: 14px auto 12px;
          }
        }

        &__select {
          display: flex;
          align-items: center;
          margin-left: 14px;
          margin-right: 27px;
          color: $color-crimson;
          min-width: 170px;
          font-size: 13px;
          height: 30px;
          flex-grow: 0.5;
        }

        &-checkboxes {
          display: flex;
          align-items: center;
          width: 170px;
          user-select: none;

          &__checkbox {
            margin-right: 16px;

            &_payments {
              margin-right: 8px;
            }
          }
        }
      }

      &-card {
        width: 415px;
        background: $color-white;
        box-shadow: 0 0 25px rgba($color-black, 0.06);
        border-radius: 5px;
        margin: 9px auto 22px;
        padding: 17px;
        font-size: 10px;
        font-weight: 600;
        line-height: 17px;
        text-align: center;

        &__item {
          margin-bottom: 8px;

          pre {
            white-space: pre-line;
          }

          &_iban {
            font-size: 10px;
          }
        }
      }
    }

    &-footer {
      width: 100%;
      font-size: 11px;
      line-height: 15px;
      text-align: center;

      &__row {
        margin-bottom: 18px;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPProforma/BBPProforma.vue